export default function({ state, commit, dispatch }, filter) {
    commit('startEditingFilter')

    return dispatch('delete', {
        url: '/provider/' + state.id + '/filter/' + filter.id
    }, {
        root: true
    })
    .then((response) => {
        commit('finishEditingFilter')
        commit('removeFilter', response)
		return response
    })
    .catch((error) => {
        commit('finishEditingFilter')
		throw error
    })
}
